export default __webpack_public_path__ + "assets/f6a4cd0432f1db23eb9fd40e5d136ba3.woff";